import { registerAction } from '../../Action'

const LOGIN_ERROR = 'LOGIN_ERROR'

const reducer = (state = {}, action) => ({
  ...state,
  login_errors: [...(state.login_errors || []), action.payload],
})

const loginError = registerAction(LOGIN_ERROR, { reducer })

export default loginError
